import React from "react";

const Help = () => {
  return (
    <div className="content">
      <h1>Hilfe</h1>
      <p />
    </div>
  );
};

export default Help;



/** WEBPACK FOOTER **
 ** ./src/components/Help.jsx
 **/